<template>
    <div v-if="isSuperAdmin">
        <LaPageHeader heading="Users">
            <template #controls>
                <LaBaseButton text="Add user" icon="plus" data-test="add-user" id="add-user" @click="addUser()" />
            </template>
        </LaPageHeader>

        <div class="columns">
            <div class="column">
                <UsersCard />
            </div>
        </div>

        <LaDialog name="userForm" size="large">
            <UserForm></UserForm>
        </LaDialog>

        <LaDialog name="userDelete">
            <LaDeleteConfirmDialog item-name="user" item-property="email" />
        </LaDialog>
    </div>
</template>

<script>
import LaPageHeader from "@/components/PageHeader";
import LaDialog from "@/components/dialog/Dialog";
import LaBaseButton from "@/components/button/BaseButton";
import LaDeleteConfirmDialog from "@/components/dialog/DeleteConfirmDialog";
import UserForm from "@/components/dialog/UserForm";
import UsersCard from "@/components/users/UsersCard";
import store from "@/store/store";
import { mutationTypes as dialogMutationTypes } from "@/store/Dialog/types";
import { computed } from "vue";
import { getterTypes } from "@/store/LoggedUser/types";

export default {
    name: "UsersView",
    components: {
        LaPageHeader,
        UsersCard,
        UserForm,
        LaDialog,
        LaBaseButton,
        LaDeleteConfirmDialog,
    },
    setup() {
        const userRights = computed(() => store.getters[getterTypes.getUserRights]);
        const isSuperAdmin = computed(() => userRights.value && userRights.value["super_admin"]);

        console.log("UsersView setup - userRights:", userRights.value);
        console.log("UsersView setup - isSuperAdmin:", isSuperAdmin.value);

        const addUser = () => {
            store.commit(dialogMutationTypes.openDialog, {
                dialogName: "userForm",
                dialogHeading: "Add user",
            });
        };

        return { addUser, isSuperAdmin };
    },
};
</script>

<style scoped></style>
